<template>
  <div>
    <v-card class="mx-auto" max-width="500">
      <v-card-title class="title font-weight-regular justify-space-between">
        <span>{{ currentTitle }}</span>
        <v-avatar
          color="primary lighten-2"
          class="subheading white--text"
          size="24"
          v-text="step"
        ></v-avatar>
      </v-card-title>

      <v-window v-model="step">
        <v-window-item :value="1">
          <v-card-text>
            <v-text-field
              label="Email"
              value=""
              v-model="userEmail"
              :error-messages="emailErrors"
              required
              @input="$v.userEmail.$touch()"
              @blur="$v.userEmail.$touch()"
              v-on:keyup.enter="$refs.nextStepButton.$el.click()"
              ref="userEmailInputField"
            ></v-text-field>
            <span class="caption grey--text text--darken-1">
              This is the email you will use to login to your Think Home account
            </span>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="2">
          <v-card-text>
            <v-text-field
              label="Password"
              type="password"
              v-model="userPassword"
              :error-messages="passwordErrors"
              required
              @input="$v.userPassword.$touch()"
              @blur="$v.userPassword.$touch()"
              ref="userPasswordInputField"
            ></v-text-field>
            <v-text-field
              label="Confirm Password"
              type="password"
              v-model="userPasswordConfirm"
              :error-messages="confirmPasswordErrors"
              required
              @input="$v.userPasswordConfirm.$touch()"
              @blur="$v.userPasswordConfirm.$touch()"
              v-on:keyup.enter="$refs.nextStepButton.$el.click()"
            ></v-text-field>
            <span class="caption grey--text text--darken-1">
              Please enter a password for your account
            </span>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="3">
          <div
            v-if="!$store.state.AuthStore.signUpUser"
            class="pa-3 text-xs-center"
          >
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
          <div v-else class="pa-3 text-xs-center">
            <!--          <v-img-->
            <!--                  class="mb-3"-->
            <!--                  contain-->
            <!--                  height="128"-->
            <!--                  src="https://cdn.vuetifyjs.com/images/logos/v.svg"-->
            <!--          ></v-img>-->
            <h3 class="title font-weight-light mb-2">
              Hello, {{ $store.state.AuthStore.signUpUser.email }}<br />Welcome
              to Case3D Think Home Platform
            </h3>
            <span class="caption grey&#45;&#45;text"
              >Thanks for signing up!</span
            >
            <span class="caption grey&#45;&#45;text"
              >Please check your email, we have sent you an email with account
              confirmation link...</span
            >
          </div>
        </v-window-item>
      </v-window>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          :disabled="step === 1 || step === 3"
          @click="stepSkip('back')"
          ref="backStepButton"
        >
          Back
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="nextButtonDisabled"
          color="primary"
          depressed
          @click="stepSkip('next')"
          ref="nextStepButton"
        >
          {{ nextButtonLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <ErrorDialog
      v-if="$store.state.errors.length > 0"
      :showDialog="$store.state.errors.length > 0"
      :errors="$store.state.errors"
      @clickedOk="onClickOkErrorDialog"
    ></ErrorDialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'
import ErrorDialog from '../components/ErrorDialog'

export default {
  mixins: [validationMixin],
  components: {
    ErrorDialog
  },
  data: () => ({
    step: 1,
    userEmail: '',
    userPassword: '',
    userPasswordConfirm: '',
    userSignUp: false
  }),
  methods: {
    stepSkip: function(direction) {
      if (direction === 'back') {
        this.step--
      } else {
        if (this.step === 2) {
          this.$store
            .dispatch('AuthStore/signUpUser', {
              username: this.userEmail,
              password: this.userPassword
            })
            .then(() => {
              if (!this.$store.state.AuthStore.signUpErrorStatus) {
                this.step++
              }
            })
        } else if (this.step === 3) {
          this.$store.dispatch('AuthStore/signUpComplete')
          this.step++
        } else if (this.step === 1) {
          this.step++
        }
      }
      this.focusField()
    },
    onClickOkErrorDialog: function() {
      this.userPassword = ''
      this.userPasswordConfirm = ''
      this.step = 1
      this.focusField()
    },
    focusField: function() {
      switch (this.step) {
        case 1:
          setTimeout(() => {
            this.$nextTick(this.$refs.userEmailInputField.focus)
          }, 500)
          break
        case 2:
          setTimeout(() => {
            this.$nextTick(this.$refs.userPasswordInputField.focus)
          }, 500)
          //this.$nextTick()
          break
        case 3:
          setTimeout(() => {
            this.$nextTick(this.$refs.nextStepButton.focus)
          }, 500)
          break
        default:
      }
    }
  },
  validations: {
    userEmail: {
      email,
      required
    },
    userPassword: {
      required,
      minLength: minLength(5)
    },
    userPasswordConfirm: {
      sameAsPassword: sameAs('userPassword')
    }
  },
  computed: {
    currentTitle() {
      switch (this.step) {
        case 1:
          return 'Sign-up'
        case 2:
          return 'Create a password'
        default:
          return 'Account created'
      }
    },
    emailErrors() {
      const errors = []
      if (!this.$v.userEmail.$dirty) return errors
      !this.$v.userEmail.email && errors.push('Must be valid e-mail')
      !this.$v.userEmail.required && errors.push('E-mail is required')
      return errors
    },
    passwordErrors() {
      const errors = []
      if (!this.$v.userPassword.$dirty) return errors
      !this.$v.userPassword.required && errors.push('Password is required')
      !this.$v.userPassword.minLength &&
        errors.push('Password must be at leas 6 characters')
      return errors
    },
    confirmPasswordErrors() {
      const errors = []
      if (!this.$v.userPasswordConfirm.$dirty) return errors
      !this.$v.userPasswordConfirm.sameAsPassword &&
        errors.push('Passwords must be identical')
      return errors
    },
    nextButtonDisabled() {
      switch (this.step) {
        case 1:
          if (this.userEmail === '' && this.emailErrors.length === 0) {
            return true
          } else {
            return this.emailErrors.length !== 0
          }
        case 2:
          if (this.userPassword === '' && this.passwordErrors.length === 0) {
            return true
          } else {
            return (
              this.passwordErrors.length !== 0 ||
              this.confirmPasswordErrors.length !== 0
            )
          }
        case 3:
          return false
        default:
          return true
      }
    },
    nextButtonLabel() {
      switch (this.step) {
        case 1:
          return 'Next'
        case 2:
          return 'Next'
        case 3:
          return 'OK'
        default:
          return ''
      }
    }
  },
  created: function() {},
  mounted: function() {
    this.focusField()
  }
}
</script>

<style scoped></style>
